
import { l, tryGetTokenOverride, selectLanguage } from "./localization.js";


// Translations for tours
export const general = {


    
    entry(number, locale) {

        const overrideTranslation = tryGetTokenOverride(locale, "entry");

        if (overrideTranslation) {
            return overrideTranslation;
        }
        
        switch(number) {
            case 1: return l.app.tours.general.singular(locale);
            default: return l.app.tours.general.plural(locale);
        }
            
    },
            

    
    singular(locale) {

        const overrideTranslation = tryGetTokenOverride(locale, "singular");

        if (overrideTranslation) {
            return overrideTranslation;
        }
        
        const language = selectLanguage(locale, ["en", "de"]);

        switch (language) {
            case "en": return "Tour";
            case "de": return "Rundgang";
            default: return `[singular: ${language} missing]`;
        }
    
    },
            

    
    plural(locale) {

        const overrideTranslation = tryGetTokenOverride(locale, "plural");

        if (overrideTranslation) {
            return overrideTranslation;
        }
        
        const language = selectLanguage(locale, ["en", "de"]);

        switch (language) {
            case "en": return "Tours";
            case "de": return "Rundgänge";
            default: return `[plural: ${language} missing]`;
        }
    
    },
            
};
